/* Pannproffsen product pages. Native Shopify cart form; no custom cart transport. */
(() => {
  if (window.__ppProductPages) {
    window.__ppProductPages.init(document);
    return;
  }

  const instances = new Map();

  function init(scope) {
    const roots = [...scope.querySelectorAll('[data-ppdp], [data-pppd]')];

    if (scope.matches?.('[data-ppdp], [data-pppd]')) {
      roots.unshift(scope);
    }

    roots.forEach(root => {
      if (instances.has(root)) return;

      const abort = new AbortController();
      const on = (node, type, fn) =>
        node?.addEventListener(type, fn, { signal: abort.signal });

      instances.set(root, abort);

      const select = root.querySelector('[data-ppdp-variant]');
      const qty = root.querySelector('[data-ppdp-quantity]');
      const currency = root.dataset.currency || 'SEK';

      const formatter = new Intl.NumberFormat('sv-SE', {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });

      const money = cents => formatter.format(Number(cents) / 100);

      function showMedia(id) {
        if (
          !id ||
          ![...root.querySelectorAll('[data-ppdp-media]')].some(
            node => node.dataset.ppdpMedia === id
          )
        ) {
          return;
        }

        root.querySelectorAll('[data-ppdp-media]').forEach(node => {
          const active = node.dataset.ppdpMedia === id;
          node.hidden = !active;

          if (!active) {
            node.querySelectorAll('video').forEach(video => video.pause());

            node.querySelectorAll('iframe').forEach(frame => {
              // Unload inactive external players so playback cannot continue offscreen.
              if (!frame.dataset.ppSrc) {
                frame.dataset.ppSrc = frame.getAttribute('src');
              }

              if (frame.getAttribute('src') !== 'about:blank') {
                frame.setAttribute('src', 'about:blank');
              }
            });
          } else {
            node.querySelectorAll('iframe[data-pp-src]').forEach(frame => {
              frame.setAttribute('src', frame.dataset.ppSrc);
            });
          }
        });

        root.querySelectorAll('[data-ppdp-thumb]').forEach(button => {
          button.setAttribute(
            'aria-pressed',
            String(button.dataset.ppdpThumb === id)
          );
        });
      }

      root.querySelectorAll('[data-ppdp-thumb]').forEach(button => {
        on(button, 'click', () => showMedia(button.dataset.ppdpThumb));
      });

      function updateVariant(updateUrl) {
        const option = select?.selectedOptions[0];
        if (!option) return;

        const data = option.dataset;
        const available = data.available === 'true';

        root.querySelector('[data-ppdp-price]').textContent = money(data.price);

        const vat = root.querySelector('[data-ppdp-vat]');
        if (vat) {
          vat.textContent = money(
            data.vat ?? Math.round(Number(data.price) / 5)
          );
        }

        const compare = root.querySelector('[data-ppdp-compare]');
        compare.hidden = !(Number(data.compare) > Number(data.price));
        compare.textContent = money(data.compare);

        const availability = root.querySelector('[data-ppdp-availability]');

availability.textContent = available
  ? (data.stockLabel || 'Kan beställas')
  : 'Slut i lager';

availability.dataset.stockStatus = available
  ? (data.stockStatus || 'order_item')
  : 'sold_out';

        root.querySelector('[data-ppdp-add]').disabled = !available;

        root.querySelector('[data-ppdp-add-label]').textContent =
          available ? 'Lägg i varukorg' : 'Slut i lager';

        const sku = root.querySelector('[data-ppdp-sku]');
        sku.hidden = !data.sku;
        sku.textContent = data.sku ? `Artikelnummer: ${data.sku}` : '';

        if (qty) {
          qty.min = data.min || '1';
          qty.step = data.step || '1';

          if (data.max) {
            qty.max = data.max;
          } else {
            qty.removeAttribute('max');
          }

          const min = Number(qty.min);
          const step = Number(qty.step);
          const current = Number(qty.value);

          if (
            !Number.isFinite(current) ||
            current < min ||
            (current - min) % step !== 0 ||
            (qty.max && current > Number(qty.max))
          ) {
            qty.value = String(min);
          }
        }

        showMedia(data.media);

        if (updateUrl && !window.Shopify?.designMode) {
          const url = new URL(location.href);
          url.searchParams.set('variant', option.value);
          url.searchParams.delete('option_values');
          history.replaceState(history.state, '', url);
        }
      }

      on(select, 'change', () => updateVariant(true));

      if (select) {
        updateVariant(false);
      }

      on(
        root.querySelector('[data-ppdp-minus]'),
        'click',
        () => qty.stepDown()
      );

      on(
        root.querySelector('[data-ppdp-plus]'),
        'click',
        () => qty.stepUp()
      );

      // Native scroll snapping supports touch, keyboard and pages without JS.
      const track = root.querySelector('[data-pppd-slides]');

      if (track) {
        const slides = [...track.querySelectorAll('.pppd__slide')];
        const nav = root.querySelector('[data-pppd-gallery-nav]');
        const prev = root.querySelector('[data-pppd-prev]');
        const next = root.querySelector('[data-pppd-next]');

        const currentIndex = () => {
          const left = track.getBoundingClientRect().left;

          return slides.reduce(
            (best, slide, index) =>
              Math.abs(slide.getBoundingClientRect().left - left) <
              Math.abs(slides[best].getBoundingClientRect().left - left)
                ? index
                : best,
            0
          );
        };

        const sync = () => {
          const index = currentIndex();

          root.querySelector('[data-pppd-counter]').textContent =
            `${index + 1} / ${slides.length}`;

          prev.disabled = index === 0;
          next.disabled = index === slides.length - 1;
        };

        const go = direction => {
          const index = Math.max(
            0,
            Math.min(slides.length - 1, currentIndex() + direction)
          );

          const delta =
            slides[index].getBoundingClientRect().left -
            track.getBoundingClientRect().left;

          track.scrollBy({
            left: delta,
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches
              ? 'auto'
              : 'smooth'
          });
        };

        if (slides.length > 1) {
          nav.hidden = false;
        }

        on(prev, 'click', () => go(-1));
        on(next, 'click', () => go(1));
        on(track, 'scroll', sync);

        sync();
      }

      on(document, 'shopify:block:select', event => {
        if (!root.contains(event.target)) return;

        event.target.closest('details')?.setAttribute('open', '');

        const slide = event.target.closest('.pppd__slide');

        if (slide && track) {
          track.scrollBy({
            left:
              slide.getBoundingClientRect().left -
              track.getBoundingClientRect().left
          });
        }
      });
    });
  }

  window.__ppProductPages = { init };

  document.addEventListener('shopify:section:load', event => {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((abort, root) => {
      if (root === event.target || event.target.contains(root)) {
        abort.abort();
        instances.delete(root);
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => init(document),
      { once: true }
    );
  } else {
    init(document);
  }
})();